import cx from 'classnames'
import React from 'react'
import { LogoImg, LogoText } from '../../../assets'
import './Navbar.scss'

function Navbar({onClick,closeSide}) {

  const classTogleNav = cx({
    'toggleNav' : true,
    'close' : closeSide
  })


  return (
    <div className="mainNavbar">
      <div className="left">
        <img src={LogoImg} alt="logo" className="logoImg" />
        <img className="logoText" alt="logo" src={LogoText} />
      </div>
      <div className="right" onClick={onClick}>
        <div className={classTogleNav}>
          <span className="_bar top"></span>
          <span className="_bar center"></span>
          <span className="_bar top"></span>
        </div>
      </div>
    </div>
  )
}

export default Navbar
